import React, { useEffect, useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import Button from '../Button';
import Form, { useForm } from '../Form';
import Field from '../Field';
import { StyledAddChatModal } from './AddChatModal.style';
import sessionsService from '../../services/sessionsServices';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../Context/authContext';
import Loaders from '../Loaders';
import { useParams } from 'react-router-dom';
import projectService from '../../services/projectService';
import Toast from '../Toast';

const AddChatModal = ({ onClose, refetch }) => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const [form] = useForm();
  const { user } = useContextHook(AuthContext, v => ({
    user: v.user,
  }));
  const payload = {
    platform_id: 'dryvelabs',
    user_id: user?.data?.ID,
    project_id: 'test',
  };
  const { sessions_loading, sessions_data } = sessionsService.GetSessionsList(payload);
  const [sessionData, setSessionData] = useState();
  const [selectedSessions, setSelectedSessions] = useState([]);

  const handleCheckboxChange = session => {
    console.log(session);
    setSelectedSessions(prev => {
      const exists = prev.some(item => item.session_id === session.id);

      if (exists) {
        return prev.filter(item => item.session_id !== session.id);
      } else {
        return [
          ...prev,
          {
            session_id: session?.id,
            initial_message: session?.initial_message,
            updated_at: session?.updated_at,
            title: session?.title,
          },
        ];
      }
    });
  };
  const AddSession = async () => {
    setLoading(true);
    try {
      const payload = {
        project_id: id,
        sessions: selectedSessions,
      };
      const resp = await projectService.createProjectSessions(payload);
      refetch();
      setLoading(false);
      onClose();
      Toast({ type: 'success', message: resp?.detail });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (sessions_data) {
      function mergeSessions(sessions) {
        return Object.values(sessions)
          .flat()
          .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
      }
      const allSessions = mergeSessions(sessions_data?.sessions);
      setSessionData(allSessions);
    }
  }, [sessions_data]);
  return (
    <StyledAddChatModal>
      <div className="content-box">
        <Form form={form}>
          <div className="input-holder">
            <Form.Item
              type="search"
              rounded
              name="text"
              prefix={<FiSearch size="26" style={{ color: '#9D9D9D' }} />}
              placeholder="Search your chats to add them in “My Research Project”">
              <Field />
            </Form.Item>
            <div className="holder">
              {sessions_loading && <Loaders loading />}
              {!sessions_loading &&
                sessionData.map((elem, ind) => (
                  <Field
                    onChange={() => handleCheckboxChange(elem)}
                    key={ind}
                    type="checkbox"
                    label={
                      <div className="text-holder">
                        <strong className="title" dangerouslySetInnerHTML={{ __html: elem.title }} />
                        <div className="description">
                          <p dangerouslySetInnerHTML={{ __html: elem.initial_message }} />
                        </div>
                        <span className="date">{elem.updated_at}</span>
                      </div>
                    }
                  />
                ))}
            </div>
          </div>
        </Form>
      </div>
      <div className="btn-holder">
        <Button width="150px" variant="secondary-outline" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button width="150px" onClick={AddSession} loader={loading}>
          Add Chats {selectedSessions?.length > 0 && `(${selectedSessions?.length})`}
        </Button>
      </div>
    </StyledAddChatModal>
  );
};

export default AddChatModal;
